import { useEffect } from 'react';

// Zet een unieke <title> en meta description per pagina (SEO; voorkomt duplicate titles/descriptions).
export function useDocumentMeta(title, description, canonicalPath) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    const setMeta = (attr, key, value) => {
      if (!value) return null;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      let created = false;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
        created = true;
      }
      const prev = el.getAttribute('content');
      el.setAttribute('content', value);
      return { el, prev, created };
    };

    const restorers = [
      setMeta('name', 'description', description),
      setMeta('property', 'og:title', title),
      setMeta('property', 'og:description', description),
      setMeta('name', 'twitter:title', title),
      setMeta('name', 'twitter:description', description),
    ].filter(Boolean);

    let canonical = null;
    let canonicalCreated = false;
    let canonicalPrev = null;
    if (canonicalPath) {
      canonical = document.head.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
        canonicalCreated = true;
      } else {
        canonicalPrev = canonical.getAttribute('href');
      }
      canonical.setAttribute('href', `https://monteurcentraal.com${canonicalPath}`);
    }

    return () => {
      document.title = prevTitle;
      restorers.forEach(({ el, prev, created }) => {
        if (created) el.remove();
        else if (prev !== null) el.setAttribute('content', prev);
      });
      if (canonical) {
        if (canonicalCreated) canonical.remove();
        else if (canonicalPrev !== null) canonical.setAttribute('href', canonicalPrev);
      }
    };
  }, [title, description, canonicalPath]);
}
